import React, { useState, useEffect } from "react";
import { toast } from "react-hot-toast";

import { Popup } from "components/UI/Popup";
import { PrefOption } from "./PrefOption";
import { FORM_FIELDS } from "./constants";
import { useMeQuery, useUpdateVisitorInfoMutation } from "queries";
import "./style/PreferencesPopup.scss";

export const PreferencesPopup = () => {
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [isSendingData, setSendingData] = useState(false);
  const [prefOptions, setPrefOptions] = useState(FORM_FIELDS);
  const updateVisitorInfoMutation = useUpdateVisitorInfoMutation();
  const { data } = useMeQuery();

  useEffect(() => {
    console.debug("Visitor info changes, checking for preferences.");

    const shouldShowPopup = () => {
      if (!data) {
        return false;
      }

      if (data.preferences?.length) {
        return false;
      }

      return true;
    };

    if (shouldShowPopup()) {
      setShowPopup(true);
      console.debug("Showing the preferences dialog.");
    }
  }, [data]);

  const handleCheckBoxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const targetName = event.target.name;
    const copyOptions = [...prefOptions];

    for (const filed of copyOptions) {
      if (filed.name === targetName) {
        filed.isChecked = !filed.isChecked;
      }
    }

    setPrefOptions([...copyOptions]);
  };

  const canSend = (): boolean => {
    const selected = prefOptions.filter((x) => x.isChecked);
    return !isSendingData && selected.length > 0; // isSendingData
  };

  const handleSubmit = async (e: React.SyntheticEvent) => {
    e.preventDefault();
    setSendingData(true);

    const filterCheckedPrefs = prefOptions.filter(({ isChecked }) => isChecked);
    const prefValues = filterCheckedPrefs.length ?
      filterCheckedPrefs.map(({ value }) => value) : [];

    const dataToSend = [
      {
        path: "/preferences",
        value: prefValues
      }
    ];

    try {
      await updateVisitorInfoMutation.mutateAsync(dataToSend);
      setShowPopup(false);
    } catch (err) {
      toast.error("Error saving preferences, please try again.");
      console.error("Error saving preferences.");
    } finally {
      console.debug("Closing the preferences popup.");
      setSendingData(false);
    }
  };

  const btnProps = {
    type: 1,
    title: isSendingData ? "Sending..." : "Save",
    onClick: handleSubmit,
    disabled: !canSend()
  };

  return (
    <Popup
      title="Define Your Preferences"
      isOpen={showPopup}
      popupClass="PopupPreferences"
      btnProps={btnProps}
    >
      <div className="PopupPreferences-Cnt">
        <p className="PopupPreferences-Description">Customize your RedGIFs experience by selecting what you'd like to see:</p>
        <div className="PopupPreferences-Form">
          {prefOptions.map((filed, index) => (
            <PrefOption key={index} handleCheckbox={handleCheckBoxChange} {...filed} />
          ))}
        </div>
      </div>
    </Popup>
  );
};
